var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0"},[_c('v-layout',[(_vm.radio === 3)?_c('v-flex',[_c('Payment-table')],1):_c('v-flex',{attrs:{"xs12":""}},[_c('accumulation-table',{on:{"refresh":function($event){return _vm.$emit('refresh')}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea278eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/supplier-payments/SupplierPaymentsTableContainer.vue
// module id = null
// module chunks = 